/**
 * Firebase Configuration
 *
 * Connects to Rationale's Firebase project for authentication and feature gating
 */

import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics, isSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);

// Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account',
});

// Analytics (only in production)
export const analytics = isSupported().then((yes) => (yes ? getAnalytics(app) : null));

// Feature flag configuration
export const featureFlags = {
  requireAuth: import.meta.env.VITE_REQUIRE_AUTH === 'true',
  allowedTesters: import.meta.env.VITE_ALLOWED_TESTERS?.split(',')
    .map((email: string) => email.trim())
    .filter(Boolean) || [],
  adminEmails: import.meta.env.VITE_ADMIN_EMAILS?.split(',')
    .map((email: string) => email.trim())
    .filter(Boolean) || [],
};
